import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Logo } from '../components/ui/Logo';
interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}
const BULLETS = ['CRM privado para tu empresa desde el primer minuto', 'Formularios y landings personalizables sin tocar código', 'Cada lead entra automáticamente en tu pipeline'];
export function AuthLayout({
  title,
  subtitle,
  children,
  footer
}: AuthLayoutProps) {
  return <div className="flex min-h-screen w-full bg-background" data-id="element-870" data-mp="zz7bbxppvj21">
      <main className="flex w-full flex-col justify-center px-5 py-10 sm:px-10 lg:w-1/2" data-id="element-871" data-mp="m6re5djhyf91">
        <div className="mx-auto w-full max-w-md" data-id="element-872" data-mp="q7bculjpxqxa">
          <Link to="/" className="mb-10 inline-flex" aria-label="Ir al inicio" data-id="element-873" data-mp="q82yp4nikaad">
            <Logo size={30} data-id="element-874" data-mp="c9cyhg5eduhs" />
          </Link>
          <h1 className="text-2xl font-semibold tracking-tight text-navy sm:text-3xl" data-id="element-875" data-mp="h752v9n8b92v">
            {title}
          </h1>
          <p className="mt-2 text-sm text-muted-foreground" data-id="element-876" data-mp="25j3vt2kble8e">{subtitle}</p>
          <div className="mt-8" data-id="element-877" data-mp="20kiwd5cw6yl0">{children}</div>
          {footer && <div className="mt-6 text-sm" data-id="element-878" data-mp="20k0r5j895a0y">{footer}</div>}
        </div>
      </main>

      <aside className="hidden w-1/2 flex-col justify-center border-l border-border bg-surface px-12 lg:flex" data-id="element-879" data-mp="2ej8soirw0u8b">
        <div className="max-w-md" data-id="element-880" data-mp="29miclvg31ymw">
          <p className="text-xs font-semibold uppercase tracking-wider text-primary" data-id="element-881" data-mp="29je3cjnrgcpd">
            Sistema AVA
          </p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-navy" data-id="element-882" data-mp="1huayb1o1uybo">
            Atracción, Viralidad y Automatización en un solo lugar.
          </h2>
          <ul className="mt-8 space-y-4" data-id="element-883" data-mp="1vnipwtc4rttd">
            {BULLETS.map(bullet => <li key={bullet} className="flex gap-3 text-sm text-muted-foreground" data-id="element-884" data-mp="1qto7dt89hkvv">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-primary/10" data-id="element-885" data-mp="134d2q0nsj6cg">
                  <CheckIcon className="h-3 w-3 text-primary" aria-hidden="true" data-id="element-886" data-mp="y5aaxhwtmwmf" />
                </span>
                {bullet}
              </li>)}
          </ul>
        </div>
      </aside>
    </div>;
}